<ng-container *ngIf="(isLoggedIn$ | async)">
  <ng-container *ngIf="!(isLoading$ | async); else loading">
    <nz-rate class="favourites-badge" [nzCount]="1"
             [ngModel]="isFavourite$ | async"
             (ngModelChange)="onChangeFavourite($event)"></nz-rate>
  </ng-container>
</ng-container>
<ng-template #loading>
  <span class="loading-icon"
    nz-icon nzType="icons/fontawesome/solid:circle-notch" nzSpin></span>
</ng-template>
